import type { ListPageConfig } from '../types'

/**
 * `ListPageConfig`, not `FilterConfig`.
 *
 * Dev re-added the People directory (f94d3b68) against `useListFilters`, which this branch had
 * already deleted along with `getFilterStore` and most of `url_sync` — two URL-state systems were
 * one too many, and `useListPageState` won. Restoring the old hook for this one page would have
 * reinstated exactly the duplication that deletion removed, and `PeoplePage` would have been the
 * fifth caller to migrate later anyway.
 *
 * `naturalPersons` has no server-side search or pagination, so nothing here is `serverSide` —
 * the term narrows already-fetched rows, same as the page dev wrote.
 */
export const peopleFilterConfig: ListPageConfig = {
  routeId: '/people/',
  pageId: 'people',
  pagination: { pageSize: 20 },
  fields: [
    {
      id: 'search',
      label: 'Search',
      type: 'search',
      placeholder: 'Search people...',
    },
  ],
}
